// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import VenueDto from 'common/dto-types/venue-dto';
import { PaginationParam, SortingParam, SortingType } from 'components/base-table/dto';
import { DefaultVisibleVenueColumns } from 'pages/venue-list-page/venue-column-config';
import { Filters } from 'react-table';

type VenueSliceStates = {
    data?: VenueDto;
    isFormOpen: boolean;
    updates: number;
    isFetchFdcpFormOpen: boolean;
    filters: Filters<any>;
    sorting: SortingParam;
    pagination: PaginationParam;
    visibleColumns: Array<string>;
};

const initialState: VenueSliceStates = {
    isFormOpen: false,
    updates: 0,
    isFetchFdcpFormOpen: false,
    filters: [],
    sorting: { sortingType: SortingType.Ascending, sortBy: 'name', searchTerm: '' },
    pagination: { pageSize: 10, pageIndex: 0 },
    visibleColumns: DefaultVisibleVenueColumns,
};

const venue = createSlice({
    name: 'venue',
    initialState,
    reducers: {
        openCreateForm(state) {
            state.isFormOpen = true;
            state.updates += 1;
        },

        openFetchFdcpForm(state) {
            state.isFetchFdcpFormOpen = true;
        },

        closeForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
            state.updates += 1;
        },

        closeFetchFdcpForm(state) {
            state.isFetchFdcpFormOpen = false;
        },

        setVenue(state, action) {
            state.data = action.payload;
        },

        setVenueListPersistence(state, action) {
            state.filters = action.payload.filters;
            state.sorting = action.payload.sorting;
            state.pagination = action.payload.pagination;
        },

        setVenueColumnsPersistence(state, action) {
            state.visibleColumns = action.payload;
        },
    },
});

export default venue.reducer;

export const {
    openCreateForm,
    openFetchFdcpForm,
    closeForm,
    closeFetchFdcpForm,
    setVenue,
    setVenueListPersistence,
    setVenueColumnsPersistence,
} = venue.actions;
